module.exports = __webpack_public_path__ + "static/media/pit.c52c8b67.png";